import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-property-info-bpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-property-info-bpams.component.scss?ngResource";
import { Component } from "@angular/core";
import { ApplicationSearchConstants } from "../../../application-search-constants";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchService } from "../../../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../../app-controller.service";
let SearchPropertyInfoBpamsComponent = class SearchPropertyInfoBpamsComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    propertyInfoErfNoLabel = ApplicationSearchConstants.FORM_CONTROLS.erfNoLabel;
    propertyInfoFarmNoLabel = ApplicationSearchConstants.FORM_CONTROLS.farmNoLabel;
    propertyInfoAllotmentLabel = ApplicationSearchConstants.FORM_CONTROLS.allotmentLabel;
    propertyInfoSgCodeLabel = ApplicationSearchConstants.FORM_CONTROLS.sgCodeLabel;
    propertyInfoErfNoFormControl = ApplicationSearchConstants.FORM_CONTROLS.erfNoFormControl;
    propertyInfoFarmNoFormControl = ApplicationSearchConstants.FORM_CONTROLS.farmNoFormControl;
    propertyInfoAllotmentFormControl = ApplicationSearchConstants.FORM_CONTROLS.allotmentFormControl;
    propertyInfoSgCodeFormControl = ApplicationSearchConstants.FORM_CONTROLS.sgCodeFormControl;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    propertyInfoForm;
    applicationSearchCallback;
    constructor(applicationSearchService, aflaModuleStrategyService, appController) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const erfNo = this.propertyInfoForm.get(this.propertyInfoErfNoFormControl).value;
        const farmNo = this.propertyInfoForm.get(this.propertyInfoFarmNoFormControl).value;
        const allotment = this.propertyInfoForm.get(this.propertyInfoAllotmentFormControl).value;
        const sgCode = this.propertyInfoForm.get(this.propertyInfoSgCodeFormControl).value;
        this.applicationSearchCallback(this.applicationSearchService.searchByPropertyInfo(erfNo, farmNo, allotment, sgCode, this.aflaModuleStrategyService, Number(this.appController.selectedModuleID)));
    }
    setUpForm() {
        this.propertyInfoForm = new FormGroup({
            erfNoFormControl: new FormControl(""),
            farmNoFormControl: new FormControl(""),
            allotmentFormControl: new FormControl(""),
            sgCodeFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService }
    ];
};
SearchPropertyInfoBpamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-property-info-bpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SearchPropertyInfoBpamsComponent);
export { SearchPropertyInfoBpamsComponent };
